import React, { Component } from 'react'
import Button from '@mui/material/Button'
import NavigateNext from '@mui/icons-material/NavigateNext'

class NextButton extends Component {
    constructor(props){
        super(props)
    }
    render() {
        return <Button 
                    style={{width:'100%', margin:'0'}}
                    variant="contained" 
                    color="primary" 
                    onClick={() => {this.props.saveRemaining()}}>
                Next <NavigateNext />
        </Button>
    }
}

export default NextButton